import firebase from "firebase/app";
import "firebase/firebase-firestore";
import firebaseConfig from "./firebaseConfig";

var firebaseui = require("firebaseui");

var firebaseApp = firebase.initializeApp(firebaseConfig);
var Firestore = firebaseApp.firestore();
var FireAuth = firebaseApp.auth();
var FirebaseUI = new firebaseui.auth.AuthUI(FireAuth);
FireAuth.setPersistence(firebase.auth.Auth.Persistence.SESSION);
var _firebase$firestore = firebase.firestore,
    Timestamp = _firebase$firestore.Timestamp,
    GeoPoint = _firebase$firestore.GeoPoint;
export { Timestamp, GeoPoint, Firestore, FirebaseUI, FireAuth };